import AddIcon from '@material-ui/icons/Add';
import React, { useCallback, useContext } from 'react';

import Button from 'Common/Button';

import { AssigmentEmployeeContext } from '../../assigment-employee.context';
import AssigmentEmployeeForm from '../form';

export default function Add() {
  const { setNewDialogOpened, newDialogOpened, reload } = useContext(AssigmentEmployeeContext);

  const closeDialog = useCallback(
    async (success: boolean) => {
      if (success) {
        await reload();
      }
      setNewDialogOpened(false);
    },
    [reload, setNewDialogOpened]
  );

  const onClick = () => {
    setNewDialogOpened(true);
  };
  return (
    <>
      <header className="text-right mt-2 mb-2">
        <Button startIcon={<AddIcon />} color="primary" onClick={onClick} className="ml-1">
          Personele göre kkd atama ekle
        </Button>
      </header>
      <AssigmentEmployeeForm onClose={closeDialog} data={null} open={newDialogOpened} />
    </>
  );
}
